import { ProductRestrictions } from 'base/product_restrictions';
import { BlocksService, EditorConfig } from 'blocks/blocks_service';
import { Project } from 'blocks/editor/model';
import { FeatureFlagsStore } from 'blocks/flag_overrides';
import { UndoManager } from 'blocks/woot_woot/undo';
import { CollabSyncer } from './collab_syncer';

/**
 * Gets the current state of the project and connects to the real-time
 * collaboration server (if enabled).
 */
export async function loadProject({
  blocksService,
  projectToken,
  hideFromPresence,
}: {
  blocksService: BlocksService;
  projectToken: string;
  hideFromPresence?: boolean;
}): Promise<{
  project: Project;
  undo: UndoManager;
  config: EditorConfig;
  flags: FeatureFlagsStore;
  sync: CollabSyncer;
  isNewProject: boolean;
  analyticsContext: object;
  productRestrictions: ProductRestrictions;
  locked: boolean;
  createdBy: number;
  createdAt: string;
}> {
  const sync = await CollabSyncer.create({
    blocksService,
    projectToken,
    userToken: await blocksService.getUserToken(),
    hideFromPresence,
  });
  return {
    project: sync.undo.mutable,
    undo: sync.undo,
    flags: new FeatureFlagsStore(sync.initMsg.editorFlags),
    config: sync.initMsg.editorConfig,
    sync,
    isNewProject: sync.initMsg.baseVersion === 0,
    analyticsContext: sync.initMsg.analyticsContext,
    productRestrictions: sync.initMsg.productRestrictions,
    locked: sync.initMsg.locked,
    createdBy: sync.initMsg.createdBy,
    createdAt: sync.initMsg.createdAt,
  };
}
